define("analytics-resources/components/analytics-resource/trending-spline", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "analytics-resources/utils/charts/chart-utils", "highcharts", "shared/utils/uuid", "social-listening/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _chartUtils, _highcharts, _uuid, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"analytics-resources/utils/charts/chart-utils",0,"highcharts",0,"shared/utils/uuid",0,"social-listening/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes {{did-insert this.chart}} {{did-update this.chart @chartData @chartState}}>
    <div class="cCH--chart" data-test-id={{@testIdChart}}>
      <div id={{this.chartId}}></div>
  
      {{#if this.showEmptyChart}}
        <div class="cCH--chart__overlay"></div>
      {{/if}}
  
      {{#if (eq @chartState "loading")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @customColor="grey"
            @text={{t "social-listening.listener.section.loading"}}
            class="u--text--uppercase"
          />
        </div>
      {{else if (eq @chartState "backfilling")}}
        <div class="cCH--chart__overlay">
          <Shared::Ui::CalculatingState
            @customColor="grey"
            @text={{html-safe (t "social-listening.listener.section.backfilling")}}
            class="u--text--uppercase u--text--center"
          />
        </div>
      {{else if (eq @chartState "no-data")}}
        <div class="cCH--chart__overlay">
          <p class="u--m__b__0">
            {{t "analytics-resources.state.no_insights"}}
          </p>
        </div>
      {{else if (eq @chartState "error")}}
        <div class="cCH--chart__overlay">
          {{#if (has-block "errorOverlay")}}
            {{yield to="errorOverlay"}}
          {{else}}
            <p class="u--m__b__0">
              {{t "analytics-resources.state.error"}}
            </p>
          {{/if}}
        </div>
      {{else if (eq @chartState "refresh-profile")}}
        <Listener::Charts::RefreshCredentials />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "GqAylCfT",
    "block": "[[[11,0],[17,1],[4,[38,0],[[30,0,[\"chart\"]]],null],[4,[38,1],[[30,0,[\"chart\"]],[30,2],[30,3]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCH--chart\"],[15,\"data-test-id\",[30,4]],[12],[1,\"\\n    \"],[10,0],[15,1,[30,0,[\"chartId\"]]],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showEmptyChart\"]],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,3],[[30,3],\"loading\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--text--uppercase\"]],[[\"@customColor\",\"@text\"],[\"grey\",[28,[37,5],[\"social-listening.listener.section.loading\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"backfilling\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--text--uppercase u--text--center\"]],[[\"@customColor\",\"@text\"],[\"grey\",[28,[37,6],[[28,[37,5],[\"social-listening.listener.section.backfilling\"],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"no-data\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"analytics-resources.state.no_insights\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"error\"],null],[[[1,\"      \"],[10,0],[14,0,\"cCH--chart__overlay\"],[12],[1,\"\\n\"],[41,[48,[30,5]],[[[1,\"          \"],[18,5,null],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"analytics-resources.state.error\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,3],\"refresh-profile\"],null],[[[1,\"      \"],[8,[39,9],null,null,null],[1,\"\\n    \"]],[]],null]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@chartData\",\"@chartState\",\"@testIdChart\",\"&errorOverlay\"],false,[\"did-insert\",\"did-update\",\"if\",\"eq\",\"shared/ui/calculating-state\",\"t\",\"html-safe\",\"has-block\",\"yield\",\"listener/charts/refresh-credentials\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/trending-spline.hbs",
    "isStrictMode": false
  });
  let TrendingSplineComponent = _exports.default = (_dec = (0, _service.inject)('highcharts-library'), (_class = class TrendingSplineComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "highchartsLibrary", _descriptor, this);
      _defineProperty(this, "chartId", `chart-split-packed-bubble-${(0, _uuid.default)()}`);
    }
    get showEmptyChart() {
      return (0, _chartUtils.showEmptyChart)(this.args.chartState);
    }
    get chartData() {
      return this.args.chartData;
    }
    get chartTitle() {
      return this.chartData?.formattedHashtagName;
    }
    get chartHeight() {
      return this.args.isLargeChart ? 130 : 120;
    }
    get chartOptions() {
      const chartColor = this.chartData?.chartColor ?? _constants.HashtagTrendChartColors.TextGray;
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          height: this.chartHeight
        },
        series: [{
          data: this.chartData?.chartSeriesData || [],
          type: 'spline',
          color: chartColor,
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          },
          zoneAxis: 'x',
          zones: [{
            value: 0,
            // Before day 0
            color: chartColor // Original color
          }, {
            color: _highcharts.default.color(chartColor).setOpacity(0.3).get() // Lighter shade of the original color
          }]
        }]
      };
    }
    get emptyChartOptions() {
      return {
        ...this.commonOptions,
        chart: {
          ...this.commonOptions.chart,
          className: 'cCH--chart--disabled'
        },
        tooltip: {
          enabled: false
        },
        series: []
      };
    }
    get commonOptions() {
      return {
        chart: {
          className: 'detailed-y-chart',
          type: 'spline',
          events: {
            load() {
              // eslint-disable-next-line @typescript-eslint/no-this-alias
              const chart = this;

              // Add text "7D" in the bottom right corner
              const text = this.renderer.text('7D', this.chartWidth - 30, this.chartHeight - 20).css({
                color: _constants.HashtagTrendChartColors.TextGray,
                fontSize: '0.85rem'
              }).add();

              // Force Highcharts to reflow the chart when the window is resized
              window.addEventListener('resize', function () {
                chart.reflow();
                text.attr({
                  x: chart.chartWidth - 30,
                  y: chart.chartHeight - 20
                });
              });
            }
          }
        },
        title: {
          useHTML: this.args.isHighlighted,
          text: this.args.isHighlighted ? `${this.chartTitle} <img src="/assets/icons/hot.svg" alt="Hot" style="height: 2rem; vertical-align: middle;" />` : this.chartTitle,
          align: 'left',
          style: {
            fontSize: this.args.isLargeChart ? '1.5rem' : '1.1rem',
            color: this.args.isHighlighted ? _constants.HashtagTrendChartColors.Green : _constants.HashtagTrendChartColors.TextBlack
          }
        },
        xAxis: {
          title: {
            text: 'TODAY',
            style: {
              color: _constants.HashtagTrendChartColors.TextGray,
              fontSize: '0.85rem'
            }
          },
          labels: {
            enabled: false
          },
          plotLines: [{
            color: 'grey',
            width: 2,
            value: 0,
            zIndex: 5,
            dashStyle: 'Dot'
          }]
        },
        yAxis: {
          title: undefined,
          visible: false,
          labels: {
            enabled: false
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      };
    }
    chart() {
      const chartOptions = this.showEmptyChart ? this.emptyChartOptions : this.chartOptions;
      this.highchartsLibrary.chart(this.chartId, chartOptions);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "highchartsLibrary", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "chart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chart"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TrendingSplineComponent);
});